export const SECONDARY_COLOR = '#e1e3e7';
export const OVERLAY_COLOR = 'rgba(0,0,0,0.3)';
export const BULLET_BACKGROUND_COLOR = '#CED6D9';
